import React from "react";
import { UseModernOrLegacyHook } from "./hooks";
import ModernOrLegacy from "./ModernOrLegacy";
import { useCustomQuery } from "utilities/hookutils";
import SelectBrand from "./SelectBrand";
import { getEsignRoute, getLegacyRouteForShow } from "./utils";
import { DocumentTypeWithoutInvoice } from "utilities/documentUtils";

interface Props {
  showId: number;
  modernOrLegacyHook: UseModernOrLegacyHook;
  documentType: DocumentTypeWithoutInvoice
}

const CreateEsignForShow = (props: Props) => {
  const [selectedBrand, setSelectedBrand] = React.useState<server.dto.BrandSmall>();

  const brandsApi = useCustomQuery({
    queryFn: () => window.CoreApi.Brand.List({ page: 1, perPage: 100 }).then(r => r.data.data),
    queryKey: ["brands"],
    enabled: props.modernOrLegacyHook.screen === "minimalCreationScreen",
    initialData: []
  });

  const onSave = () => {
    return window.CoreApi.ESign.CreateFromShow({
      showId: props.showId,
      brandId: selectedBrand.brandId,
      documentType: props.documentType,
    });
  }

  React.useEffect(() => {
    if (props.modernOrLegacyHook.screen === "minimalCreationScreen" && brandsApi.data.length === 1) {
      window.CoreApi.ESign.CreateFromShow({
        showId: props.showId,
        brandId: brandsApi.data[0].brandId,
        documentType: props.documentType,
      }).then(r => redirectToEsign(r.data.data));
    }
  }, [props.modernOrLegacyHook.screen, brandsApi.data])

  const redirectToLegacy = () => {
    window.location.href = getLegacyRouteForShow(props.documentType, props.showId);
  }

  const redirectToEsign = (itemId: number) => {
    window.location.href = getEsignRoute(props.documentType, itemId);
  }

  return <ModernOrLegacy
    modalTitle={site.currentEnvironment[props.documentType].newLabel}
    useModernOrLegacyHook={props.modernOrLegacyHook}
    redirectToLegacy={redirectToLegacy}
    isLoadingMinimalCreationScreen={brandsApi.isFetching || (!brandsApi.isFetching && brandsApi.data.length === 1)}
    newLabel={site.currentEnvironment[props.documentType].newLabel}
    submit={onSave}
    redirectToModernPage={redirectToEsign}
    sections={[{
      key: "esign",
      type: "regular",
      title: site.currentEnvironment[props.documentType].newLabel,
      fields: [{
        key: "brand",
        label: RESX.Branding.resxBranding,
        renderEditNew: () => (
          <SelectBrand
            value={selectedBrand}
            onChange={setSelectedBrand}
            options={brandsApi.data}
          />
        )
      }]
    }]}
  />
}

export default CreateEsignForShow;